module.exports = __webpack_public_path__ + "static/media/Din-01.712a42db.svg";